/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Nichtsepakreditinstitut2Inputs */



/**

* @param {_Field_Nichtsepakreditinstitut2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_nichtsepakreditinstitut2 = /** @type {((inputs?: _Field_Nichtsepakreditinstitut2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Nichtsepakreditinstitut2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Nicht SEPA Kreditinstitut")
});
export { _field_nichtsepakreditinstitut2 as "_field_nichtSepaKreditinstitut" }